/**
 * Types of alerts that can trigger notifications.
 */
export enum AlertType {
  MISSING_ASSIGNMENT = 'missing_assignment',
  DEADLINE = 'deadline',
  GRADE_DROP = 'grade_drop',
  TEST = 'test',
  WORKLOAD = 'workload',
  POSITIVE = 'positive',
  RECOMMENDATION = 'recommendation',
}
